// extracted by mini-css-extract-plugin
export default {"signature":"app__css__app-pages-SelfHelp-viewDormitory-__index__signature","toSign":"app__css__app-pages-SelfHelp-viewDormitory-__index__toSign"};